import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function brokenLink(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M57.1645 50.2127L27.8334 20.9789C25.9528 19.0883 22.844 19.0787 20.9438
        20.9885C19.0436 22.8983 19.0436 25.9779 20.9534 27.8781L50.2845 57.1119C51.2296
        58.057 52.477 58.5348 53.7245 58.5348C54.972 58.5348 56.229 58.0575 57.1837
        57.1023C59.0743 55.1921 59.0743 52.1129 57.1645 50.2127Z"
      />
      <path
        d="M43.8823 68.2793H4.90398C2.21446 68.2793 0.031517 70.4622 0.031517 73.1518C0.031517
        75.8413 2.21446 78.0242 4.90398 78.0242H43.8823C46.5718 78.0242 48.7547 75.8413 48.7547
        73.1518C48.7547 70.4622 46.5718 68.2793 43.8823 68.2793Z"
      />
      <path
        d="M73.2139 0.0671387C70.5244 0.0671387 68.3414 2.25008 68.3414 4.9396V43.9179C68.3414
        46.6074 70.5244 48.7904 73.2139 48.7904C75.9034 48.7904 78.0863 46.6074 78.0863
        43.9179V4.93914C78.0859 2.24963 75.9034 0.0671387 73.2139 0.0671387Z"
      />
      <path
        d="M213.069 196.382L183.737 167.148C181.857 165.258 178.748 165.248 176.848
        167.158C174.957 169.068 174.957 172.147 176.867 174.047L206.199 203.281C207.144 204.226
        208.391 204.704 209.639 204.704C210.886 204.704 212.143 204.227 213.088 203.272C214.978
        201.361 214.978 198.282 213.069 196.382Z"
      />
      <path
        d="M229.128 146.236H190.149C187.46 146.236 185.277 148.419 185.277 151.109C185.277
        153.798 187.46 155.981 190.149 155.981H229.128C231.817 155.981 234 153.798 234 151.109C234
        148.419 231.817 146.236 229.128 146.236Z"
      />
      <path
        d="M160.818 175.47C158.128 175.47 155.945 177.653 155.945 180.343V219.321C155.945
        222.01 158.128 224.193 160.818 224.193C163.507 224.193 165.69 222.01 165.69
        219.321V180.343C165.69 177.653 163.507 175.47 160.818 175.47Z"
      />
      <path
        d="M221.098 12.8615C204.006 -4.23069 176.185 -4.23069 159.093 12.8615L116.567
        55.3872C114.667 57.2874 114.667 60.3765 116.567 62.2767C118.467 64.1769 121.557
        64.1769 123.457 62.2767L165.982 19.7511C179.284 6.4593 200.907 6.4593 214.209
        19.7511C227.5 33.0525 227.5 54.6855 214.209 67.9869L152.204 130.002C138.912
        143.293 117.279 143.312 103.968 130.002C102.068 128.101 98.9785 128.101
        97.0783 130.002C95.1781 131.902 95.1781 134.991 97.0783 136.891C105.624 145.447
        116.86 149.715 128.086 149.715C139.321 149.715 150.547 145.437 159.093 136.891L221.098
        74.8765C238.2 57.7843 238.2 29.9537 221.098 12.8615Z"
      />
      <path
        d="M136.846 97.1135C119.734 80.0021 91.9039 80.0213 74.8313 97.1135L12.8263
        159.128C-4.27545 176.221 -4.27545 204.051 12.8263 221.143C21.3722 229.689 32.6081
        233.957 43.8339 233.957C55.0692 233.957 66.295 229.689 74.8414 221.143L117.367
        178.617C119.267 176.717 119.267 173.628 117.367 171.728C115.467 169.828 112.378
        169.828 110.477 171.728L67.9518 214.253C54.6504 227.545 33.0269 227.545 19.7255
        214.253C6.43373 200.952 6.43373 179.319 19.7255 166.018L81.7209 104.003C95.0223
        90.7213 116.655 90.7113 129.957 104.003C131.857 105.903 134.946 105.903 136.846
        104.003C138.747 102.103 138.746 99.0137 136.846 97.1135Z"
      />
    </SvgIcon>
  );
}
